var _animateTransform, _path, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "0.8 0.8",
    to: "1 1",
    beg: "0s",
    dur: "1s",
    repeatCount: "indefinite"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8D45B5",
    d: "M61.7,63.2c1,0,1.5-1.1,1.5-2.1V10.4l-9.6-9.7H2.8c-1,0-2.1,0.6-2.1,1.5v58.9c0,1,1.1,2.1,2.1,2.1H61.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 33.5,
    fill: "#E3E3E3",
    width: 50.4,
    height: 28.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8,10l-9.8-9.8C54,0.1,53.9,0,53.7,0H2.8C1.5,0,0,0.9,0,2.3v58.9C0,62.6,1.4,64,2.8,64h58.9c1.4,0,2.3-1.4,2.3-2.8V10.3         C64,10.2,63.9,10.1,63.8,10z M7.1,1h41.3v23.9c0,0.9-0.5,1.8-1.2,1.8H8.8c-0.8,0-1.8-0.9-1.8-1.8V1z M63,61.2c0,0.9-0.5,1.8-1.3,1.8         H2.8C2,63,1,62,1,61.2V2.3C1,1.5,2,1,2.8,1H6v23.9c0,1.4,1.4,2.8,2.8,2.8h38.4c1.5,0,2.2-1.5,2.2-2.8V1h4.1l9.5,9.5V61.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M6.8,0.8v24.2c0,1,1.1,2,2,2h38.4c1,0,1.5-1.1,1.5-2V0.8H6.8z M44.3,22.7h-8.6V5h8.6V22.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9,4h-0.8h-8.8c-0.3,0-0.5,0.2-0.5,0.5v18.6c0,0.3,0.2,0.5,0.5,0.5h9.6c0.3,0,0.5-0.2,0.5-0.5V4.5         C45.4,4.2,45.2,4,44.9,4z M44.3,22.7h-8.6V5h8.6V22.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon_save.394a126d49ed618f1eb9c88e25f33b55.svg";
export { ForwardRef as ReactComponent };